import ReactSelect from 'react-select';
import AsyncSelect from 'react-select/async';

//styles
import './customSelectStyles.css';

const colourStyles = {
    container: (styles, { selectProps }) => {
        const style = selectProps.style ? selectProps.style : {};
        return {
            ...styles,
            display: 'flex',
            minWidth: 60,
            height: selectProps.inputView ? '56px' : '40px',
            ...style,
        };
    },
    control: (styles, { selectProps }) => {
        const style = {};
        if (selectProps.error) {
            style.borderColor = 'red';
        }
        if (selectProps.isDisabled && selectProps.inputView) {
            style.backgroundColor = '#ffffff';
            style.opacity = '0.7';
        }
        return {
            ...styles,
            boxShadow: 'none',
            width: '100%',
            paddingLeft: 2,
            fontWeight: 600,
            fontSize: '14px',
            borderRadius: '10px',
            backgroundColor: '#F9FAF5',
            border: 0,
            ...style,
        };
    },
    menu: styles => {
        return {
            ...styles,
            zIndex: 20,
        };
    },
};
const Select = ({
    options = [],
    label,
    inputView,
    emptyOption,
    emptyOptionLabel = '',
    placeholder,
    className,
    optionsWorkaround,
    value,
    onChange,
    asyncSelect,
    isClearable,
    noOptionsCustomMessage,
    ...rest
}) => {
    if (emptyOption) {
        options.unshift({
            label: emptyOptionLabel,
            value: null,
        });
        if (!value) {
            value = {
                label: emptyOptionLabel,
                value: null,
            };
        }
    }
    const _noOptionsMessage = () => {
        if (noOptionsCustomMessage) {
            return noOptionsCustomMessage;
        }
        return 'No options';
    }
    const selectProps = {
        options,
        onChange,
        value,
        styles: colourStyles,
        theme: themeParam => {
            const newThemeParam = Object.assign({}, themeParam);
            newThemeParam.colors.primary = 'rgba(37,80,172,1)';
            newThemeParam.colors.primary25 = 'rgba(37,80,172, 0.25)';
            newThemeParam.colors.primary50 = 'rgba(37,80,172, 0.5)';
            newThemeParam.colors.primary75 = 'rgba(37,80,172, 0.75)';
            return newThemeParam;
        },
        inputView: !!(label || inputView),
        classNamePrefix: 'react-select',
        placeholder,
        className,
        isClearable: isClearable ? true : false,
        noOptionsMessage: _noOptionsMessage,
        ...rest
    };

    if (optionsWorkaround) selectProps.options = optionsWorkaround;
    if (asyncSelect) {
        return <AsyncSelect {...selectProps} />;
    }
    if (label) {
        return (
            <div className="input-block">
                <span className="input-block__label">{label}</span>
                <ReactSelect {...selectProps} />
            </div>
        );
    }
    return <ReactSelect {...selectProps} />;
};

export default Select;
